import { useEffect, useState } from 'react';
import { useTaxApiV1 } from '../../clients/quipli-service/tax/tax-api-v1';
import { ItemTaxCategory, TaxCategory } from '../../clients/quipli-service/tax/tax';
import { toast } from '../../util/toasts';
import { OrderType } from '../../clients/quipli-service/order/order';
import { Typography } from '../../components/typography/typography';
import { Spinner } from '../../components/spinner/spinner';
import { SelectForm } from '../../components/select-form/select-form';
import { ItemType } from '../../clients/quipli-service/accounting/accounting';

export const ItemTaxCategoryInput = ({
  itemId,
  itemType,
  transactionType,
  label,
  taxCategories: defaultTaxCategories,
}: {
  itemId?: string;
  itemType: ItemType;
  transactionType?: OrderType;
  label?: string;
  taxCategories?: TaxCategory[];
}) => {
  const [taxCategories, setTaxCategories] = useState<TaxCategory[] | undefined>(defaultTaxCategories);
  const [itemTaxCategory, setItemTaxCategory] = useState<
    Omit<ItemTaxCategory, 'id' | 'createdAt' | 'deletedAt'> | undefined
  >();
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const { searchTaxCategories, getTaxCategoryForItem, assignTaxCategoryToItem } = useTaxApiV1();

  async function init() {
    try {
      setIsLoading(true);
      const categories = await searchTaxCategories({});
      setTaxCategories(categories);
      setIsLoading(false);
    } catch (e) {
      toast('Unable to fetch tax categories', 'error');
    }

    try {
      const itemCategory = await getTaxCategoryForItem({ itemType, itemId, transactionType });
      setItemTaxCategory(itemCategory);
    } catch (e) {
      toast('Unable to fetch item tax categories', 'error');
    }
  }

  async function submit(taxCategoryId: string | undefined) {
    try {
      await assignTaxCategoryToItem({
        itemType,
        itemId,
        transactionType,
        taxCategoryId: taxCategoryId,
      });
      toast('Tax categories updated', 'success');
    } catch (e) {
      toast('Error updating tax categories', 'error');
    }
  }

  useEffect(() => {
    init();
  }, []);

  return (
    <div className="item-tax-categories container-v2">
      {!isLoading ? (
        <div className="input-group">
          <label>
            <Typography type="text-md" weight="semi-bold">
              {label || 'Tax Category'}:
            </Typography>
          </label>
          <SelectForm
            isMulti={false}
            isClearable={true}
            options={taxCategories?.map((t) => {
              return { value: t.id, label: t.name };
            })}
            value={taxCategories
              ?.map((t) => {
                return { value: t.id, label: t.name };
              })
              ?.find((t) => itemTaxCategory?.taxCategoryId === t.value)}
            onChange={async (t) => {
              if (t) {
                setItemTaxCategory({ taxCategoryId: t.value, itemId, itemType, transactionType });
              } else {
                setItemTaxCategory(undefined);
              }
              await submit(t?.value);
            }}
          />
        </div>
      ) : (
        <Spinner />
      )}
    </div>
  );
};
